import { axios } from '@/services/axios';

export default async function updateGCCHServiceStatus(serviceId) {
    return axios
        .post(`/Service/DirectRoutingGCCH/AcknowledgeSip/${serviceId}`, null)
        .then((res) => res.data)
        .catch((e) => e);
}
